import { render, staticRenderFns } from "./DetailsBasicFertilization.vue?vue&type=template&id=65d797ba&scoped=true&"
import script from "./DetailsBasicFertilization.vue?vue&type=script&lang=js&"
export * from "./DetailsBasicFertilization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d797ba",
  null
  
)

export default component.exports